import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const countryListFn = (redBody) => {
  try {
    const response = axiosInstance.get(API_URLS.countryList, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
